import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/Sobre";
import { pageHead, breadcrumbJsonLd } from "@/lib/seo";
import { SITE_URL } from "@/lib/seo";
import { claraVideoJsonLd } from "@/data/video";
const profilePage = {
  "@context": "https://schema.org",
  "@type": "ProfilePage",
  mainEntity: {
    "@type": "Person",
    "@id": `${SITE_URL}/sobre#clara`,
    name: "Clara Camille",
    jobTitle: "Nutricionista",
    description:
      "Nutricionista brasileira atuando na Austrália, com foco em acompanhamento personalizado para imigrantes brasileiros.",
    url: `${SITE_URL}/sobre`,
    image: `${SITE_URL}/clara-portrait-final.png`,
    nationality: "Brazilian",
    knowsLanguage: ["pt-BR", "en"],
    worksFor: { "@id": `${SITE_URL}/#business` },
    sameAs: ["https://www.instagram.com/nutriclaracamille_/", "https://www.tiktok.com/@nutriclaracamilles"],
  },
};

export const Route = createFileRoute("/sobre")({
  head: () =>
    pageHead({
      title: "Sobre a Clara Camille | Nutricionista na Austrália",
      description:
        "Conheça a história da Clara Camille, nutricionista brasileira na Austrália. Formação, abordagem e para quem é o acompanhamento nutricional.",
      path: "/sobre",
      ogDescription:
        "Conheça a história, formação e abordagem da Clara Camille, nutricionista brasileira na Austrália.",
      jsonLd: [
        claraVideoJsonLd(`${SITE_URL}/sobre`),
        breadcrumbJsonLd([{ name: "Sobre a Clara Camille", path: "/sobre" }]),
        profilePage,
      ],
    }),
  component: Page,
});
